export default "__VITE_ASSET__CRD8pkjD__"